// frontend/src/components/Footer.tsx

import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Footer = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <footer className="bg-white border-t mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex flex-col justify-center text-center px-4">
          <p className="text-sm text-gray-600 mb-1">
            MedApp by CL - All Rights Reserved - 2025
          </p>

          {user?.isAdmin && (
            <div className="flex justify-center gap-6">
              <button
                onClick={() => handleNavigation("/admin/users")}
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                Gestione Utenti
              </button>
              <button
                onClick={() => handleNavigation("/admin/documents")}
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                Gestione Documenti
              </button>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
